/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router';
import BasePage from 'pages/BasePage';
import { asset } from 'sf/helpers';
import { ROUTES } from 'constants';
import Banner from 'components/Banner';
import Benefits from 'components/Benefits';
import VideoAndContent from 'components/VideoAndContent';
import Resources from 'components/Resources';
import HowItWorks from 'components/HowItWorks';
import IdentifyContent from './components/IdentifyContent';
import { TITLE, CONTENT, TITLE2, HOWITWORKS, VIDEO_CONTENT } from './constant';
import help from 'models/help';


export default class Identify extends BasePage {
  className = 'ts-Identify';
  static title = 'ID Document Verification';
  static description = 'Trust Stamp’s automated document verification with a multi-faceted approach to fraud prevention makes comprehensive identity verification as simple as capturing a photo.';

  componentDidMount() {
    help.set({ showDemoButton: true });
  }

  componentWillUnmount() {
    help.set({ showDemoButton: false });
    super.componentWillUnmount();
  }

  render() {
    return (
      <div className={ this.rootcn() }>

        { /* banner */ }
        <Banner theme="id-capture" size="small">
          <h1>Identity Document Verification</h1>
        </Banner>

        { /* content section */ }
        <IdentifyContent />

        <Benefits sectionTitle={ TITLE } content={ CONTENT } colored={ true } />

        <HowItWorks content={ HOWITWORKS } sectionTitle={ TITLE2 } columnCount={ 4 } />

        <section className={ this.cn`__documents` }>
          <div className={ this.cn`__documents-content ts-container` }>
            <div className={ this.cn`__documents-left-content` }>
              <h6>Supported documents</h6>
              <h2>Global Document Coverage</h2>
              <p className="ts-p">Comply with global regulatory standards effortlessly. Our document verification covers 12,000+ templates from 248 countries and territories. Continuously expanding to ensure customers never face unsupported document issues. </p>
              <Link to={ ROUTES.SUPPORTED_COUNTRIES }>Explore supported documents</Link>
            </div>
            <div className={ this.cn`__documents-right-content` }>
              <img src={ asset`ai/technology-new-1.png` } alt="Trust Stamp - What we do" />
            </div>
          </div>
        </section>

        <VideoAndContent content={ VIDEO_CONTENT } />

        { /* resources section */ }
        <Resources>
          <article>
            <h6>RESOURCES</h6>
            <h2>Privacy-Protecting Power of the Irreversibly Transformed Identity Token</h2>
            <p>Learn how Trust Stamp’s tokenisation tech maximises privacy and utility of personal data to enhance risk and data protection measures with a frictionless UX</p>
            <Link to={ ROUTES.WHITEPAPER } className="ts-button--primary">Get the Whitepaper</Link>
          </article>
          <aside>
            <img
              src={ asset`/ai/privacy-paper-2.png` }
              alt="Privacy-Protecting Power of the Irreversibly Transformed Identity Token"
              width="400"
            />
          </aside>
        </Resources>
      </div>
    );
  }
}
